import {
  ENDPOINT_ADMIN_TERMINALS_ADD,
  ENDPOINT_ADMIN_TERMINALS_BIND,
  ENDPOINT_ADMIN_TERMINALS_DETAILS,
  ENDPOINT_ADMIN_TERMINALS_LIST,
  ENDPOINT_ADMIN_TERMINALS_REMOVE,
  ENDPOINT_ADMIN_TERMINALS_SET_LOGOUT,
  ENDPOINT_ADMIN_TERMINALS_UPDATE
} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const filter = require('mn-utils/filter');
const find = require('mn-utils/find');
const map = require('mn-utils/map');
const loopMap = require('mn-utils/loopMap');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequestAdmin,
} = require('../ws');


const mockAdminTerminals$ = new Emitter(loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    id: id,
    name: 'Cafe Kolberger Str. ' + id,
    imei: '351756051523999' + id,
    status: 'ordered',
    color: 'Deep Ocean',
  };
}));
let __lastId = require('../../utils/getLastIdByEmitter')(mockAdminTerminals$);

export function apiAdminTerminalsBind(params) {
  const {
    id,
  } = params;
  if (process.env.MOCK) {
    return CancelablePromise
      .delay(500, find(mockAdminTerminals$.getValue(), ['id', id]));
  }

  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_BIND, {
    ...params,
    id,
  });
}

export function apiAdminTerminalsLogoutAllUsers({id}) {
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_SET_LOGOUT, {
    id,
    is_need_logout: true
  });
}

export function apiAdminTerminalsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    const items = mockAdminTerminals$.getValue();
    return CancelablePromise.delay(500, {
      list: items.slice(offset, offset + limit),
      count: items.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_LIST, {
    ...params,
    offset,
    limit,
  });
}
export function apiAdminTerminalsGet(params) {
  const {
    id,
  } = params;
  if (process.env.MOCK) {
    return CancelablePromise
        .delay(500, find(mockAdminTerminals$.getValue(), ['id', id]));
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_DETAILS, {
    ...params,
    id,
  });
}
export function apiAdminTerminalsAdd(params) {
  if (process.env.MOCK) {
    const id = '' + __lastId++;
    mockAdminTerminals$.emit([
      {
        ...params,
        id,
      },
      ...mockAdminTerminals$.getValue(),
    ]);
    return CancelablePromise.delay(500, {id});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_ADD, params);
}
export function apiAdminTerminalsEdit(params) {
  const {
    id,
  } = params;
  if (process.env.MOCK) {
    mockAdminTerminals$.emit(map(mockAdminTerminals$.getValue(), (v) => {
      return v.id === id ? {
        ...v,
        ...params,
      } : v;
    }));
    return CancelablePromise.delay(500, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_UPDATE, params);
}
export function apiAdminTerminalsRemove(params) {
  const {
    id,
  } = params;
  if (process.env.MOCK) {
    mockAdminTerminals$.emit(
        filter(mockAdminTerminals$.getValue(), (v) => v.id !== id),
    );
    return CancelablePromise.delay(500, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_TERMINALS_REMOVE, params);
}
export function apiAdminTerminalsRemoveAll({
  ids,
  ...params
}) {
  return CancelablePromise.all(map(ids, (id) => {
    return apiAdminTerminalsRemove({
      ...params,
      id,
    });
  }));
}
